import {useEffect, useMemo} from 'react'
import {useNavigate} from 'react-router-dom'
import {useAuth} from '../../auth/hooks/useAuth'

export const RedirectionPage = () => {
  const navigate = useNavigate()
  const {user} = useAuth()

  const loginRedirectUrl = useMemo(() => {
    return `/auth/login`
  }, [])

  useEffect(() => {
    if (!user) {
      navigate(loginRedirectUrl, {replace: true})
    }
  }, [loginRedirectUrl, navigate, user])

  useEffect(() => {
    if (user) {
      navigate('/dashboard', {replace: true})
    }
  }, [navigate, user])

  return null
}
